"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Mess-Panel
 *
 * @class
 * @extends gc.gis.widget.GCPanel
 * @memberof gc.gis.module.GCMeasure
 * @author Anton Popov <a.popov@brain-scc.de>
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCMeasure} options.module Modul-Instanz
 * @param {boolean} options.enableSnap Snap aktiviert
 */
gc.gis.module.GCMeasure.Panel = function( options )
{
    var self = this;

    gc.gis.assert.isSet( options );
    gc.gis.assert.isInstance( options.module, gc.gis.module.GCMeasure );

    this.module = options.module;
    this.enableSnap = options.enableSnap;

    this.msg_require_length = '<em>2 Stützpunkte benötigt</em>';
	this.msg_require_area = '<em>3 Stützpunkte benötigt</em>';
	this.msg_require_area_close = '<em>Fläche schließen</em>';

    var options_widget = {
        className: 'gc-measure',
        //target:    '#gc_measure',
        toolbar: new gc.gis.widget.GCMenu({
            items: [
                new gc.gis.widget.GCItem({
                    label: 'Zurücksetzen',
                    className: 'btn btn-default',
                    icon: 'action-reset',
                    action: new gc.gis.module.GCMeasureResetAction({instance: self.module})
                })
            ]
        })
    };
    gc.gis.widget.GCPanel.call( this, options_widget );

    this.element = this._render();

    this._initContent();
};
gc.gis.module.GCMeasure.Panel.prototype = Object.create( gc.gis.widget.GCPanel.prototype );

/**
 * Initialisiert den Panel-Inhalt
 *
 * @protected
 * @method
 */
gc.gis.module.GCMeasure.Panel.prototype._initContent = function()
{
    var self = this;

    // Formular für Einstellungen
    if (this.enableSnap)
    {
	    var snapCtrl = this.module.map.getSnapControl();
	    if (snapCtrl)
        {
	        this._form = gc.gis.util.GCFormRenderer.renderForm({controls: snapCtrl.getFormConfig()});
        }
    }

    // Liniensegmente
    var p_segments_label = jQuery('<p>', {
        'class': 'gc-measure-segments-label',
        html: '<strong>Segmente:</strong>'
    });
    this.element_segments = jQuery('<ul>', {
        'class': 'gc-measure-segments'
    });
    this.element_segment_container = jQuery('<div>', {
        'class': 'gc-measure-segments-container',
        html: this.element_segments
    });

    // Liniensumme
    this.element_length_value = jQuery('<span>', {
        'class': 'gc-measure-value gc-measure-length-value',
        html: this.msg_require_length
    });
    this.element_length_unit = jQuery('<span>', {
        'class': 'gc-measure-unit'
    });
    var p_length = jQuery('<p>', {
        'class': 'gc-measure-length',
        html: '<span class="gc-measure-label">Gesamtlänge:</span> '
    });
    p_length.append( this.element_length_value );
    p_length.append( this.element_length_unit );

    // Fläche
    this.element_area_value = jQuery('<span>', {
        'class': 'gc-measure-value gc-measure-area-value',
        html: this.msg_require_area
    });
    this.element_area_unit = jQuery('<span>', {
        'class': 'gc-measure-unit'
    });
    var p_area = jQuery('<p>', {
        'class': 'gc-measure-area',
        html: '<span class="gc-measure-label">Fläche:</span> '
    });
    p_area.append( this.element_area_value );
    p_area.append( this.element_area_unit );

    // Zusammenfassung
    var div_summary = jQuery('<div>', {
        'class': 'gc-measure-summary'
    });
    div_summary.append( p_length );
    div_summary.append( p_area );

    // Snapping-Checkbox
    this.element_snapping = jQuery('<input>', {
        type: 'checkbox',
        click: function( evt ) {
            try
            {
                self.module.setSnappingActive( jQuery(this).is(':checked') );
            }
            catch( err )
            {
                gc.gis.iface.log.error( self, err );
            }
        }
    });

    if (this._form)
    {
	    this.element_content.append(this._form.getElement());
    }
    this.element_content.append( p_segments_label );
    this.element_content.append( this.element_segment_container );
    this.element_content.append( div_summary );
};

/**
 * Setzt die Messergebnisse zurück.
 *
 * @public
 * @method
 */
gc.gis.module.GCMeasure.Panel.prototype.resetMeasure = function()
{
    this.element_segments.children().remove();
	this.element_area_value.parent().show();
    this.element_area_value.html(this.msg_require_area);
    this.element_area_unit.html('');
    this.element_length_value.html(this.msg_require_length);
    this.element_length_unit.html('');
};

/**
 * Callback, die bei Änderung der Messgeometrien ausgeführt wird. Rendert die
 * Ergebnisse neu.
 *
 * @public
 * @method
 *
 * @param {gc.gis.module.GCMeasureObject} measure
 */
gc.gis.module.GCMeasure.Panel.prototype.onMeasureChanged = function(measure)
{
    var self = this;

    this.resetMeasure();

    this.element_length_value.html(measure.length.formattedValue);
    this.element_length_unit.html(measure.length.unit);
    if (typeof measure.area === 'object')
    {
        // Fläche vorhanden => anzeigen
	    this.element_area_value.html(measure.area.formattedValue);
	    this.element_area_unit.html(measure.area.unit);
    }
    else if (!measure.isDrawing)
    {
	    // keine Fläche vorhanden und auch nicht mehr im Zeichenmodus, => es wurde eine Linie gemessen
	    this.element_area_value.parent().hide();
    }
    else if (measure.segments.length > 2)
    {
        // Zeichnen läuft noch und mehr als 2 Segmente => Info Fläche schließen für Flächenmessung
	    this.element_area_value.html(this.msg_require_area_close);
    }

    for( var i=0; i<measure.segments.length; i++ )
    {
        var li = jQuery('<li>', {
            html: '<span class="gc-number">'+ (i+1) +':</span> '
            + '<span class="gc-value">'+ measure.segments[i].formattedValue +'</span> '
            + '<span class="gc-unit">'+ measure.segments[i].unit +'</span>'
            + '<span class="gc-value">'+ measure.cumulative[i].formattedValue +'</span> '
            + '<span class="gc-unit">'+ measure.cumulative[i].unit +'</span>'
        });
        if( measure.segments[i].feature )
        {
            li.data('__feature', measure.segments[i].feature);
            li.on('click', function( evt )
            {
                if( jQuery(this).hasClass('gc-active') )
                {
                    jQuery(this).removeClass('gc-active');
                    self.module._resetHighlighting();
                }
                else
                {
                    jQuery(this).parent().children('.gc-active').removeClass('gc-active');
                    if( jQuery(this).data('__feature') )
                    {
                        jQuery(this).addClass('gc-active');
                        self.module._highlightSegment( jQuery(this).data('__feature') );
                    }
                }
            });
        }
        this.element_segments.append( li );
    }

    this.element_segment_container.scrollTop(
        this.element_segment_container.prop('scrollHeight')
    );
};
